import { IconButton, Text } from '@chakra-ui/react'
import type { FC } from 'react'
import { useState } from 'react'

import ConfirmPopover from '@app/shared/confirmPopover'
import type { DomainBusinessContext } from '@app/types'
import ICON_MAP from '@app/utils/iconMap'
import { useBusinessContextEmptyMutation } from '@graphql/queries'

interface Props {
  businessContext: DomainBusinessContext
  onClear: () => void
}

const ClearContextButton: FC<Props> = ({ businessContext, onClear }) => {
  const [deleting, setDeleting] = useState(false)
  const [, emptyBusinessContext] = useBusinessContextEmptyMutation()

  const handleEmptyContext = async () => {
    if (!businessContext) {
      return false
    }

    setDeleting(true)
    await emptyBusinessContext({ input: { businessContextId: businessContext.id } }).finally(() => {
      setDeleting(false)
      onClear()
    })
  }

  return (
    <ConfirmPopover
      onConfirm={() => handleEmptyContext()}
      header="Clear context"
      body="Are you sure you'd like to clear the context? This action cannot be undone."
      confirmButtonText="Confirm"
    >
      <IconButton
        size="2xs"
        variant="surface"
        aria-label="Clear the existing context document"
        colorPalette="blue"
        loading={deleting}
        pl={1}
      >
        <ICON_MAP.Clear /> <Text px={1}>Clear context document</Text>
      </IconButton>
    </ConfirmPopover>
  )
}

export default ClearContextButton
